import React, { useMemo } from "react";
import { Grid } from "semantic-ui-react";
import PlusIcon from "../../../../assets/commonIcon/PlusIcon";
import { CommonTable, CustomButton, DropDown, InputText, TitleView } from "../../../../components";
import { InputNumber } from "../../../../components/InputText/InputNumber";
import { ProductUnitTable, UNIT_TYPES } from "../../../../config/constants";
import { validateProductNumber } from "../../../../utils/utils";
import { ProductUnitFormProps } from "../types/productTypes";

const ProductUnitForm: React.FC<ProductUnitFormProps> = ({
  registerUnitSize,
  errorsUnit,
  defaultType,
  setDefaultType,
  handleSubmitUnitSize,
  addUnitData,
  addProductUnit,
  enableUnitSizeAdd,
  loadTableData,
  enableSizeEditStatus,
  editUnitSize,
  control
}) => {
  const normalizedUnits = useMemo(
    () => addProductUnit.map(u => u.sales_unit_name.trim().toLowerCase()),
    [addProductUnit]
  );
  return (
    <>
      <TitleView title="Add Unit sizes" />
      <Grid>
        <Grid.Column computer={16} tablet={16} mobile={16}>
          <form>
            <Grid>
              <Grid.Column computer={3} tablet={8} mobile={16}>
                <InputText
                  register={(name: string, options: any) =>
                    registerUnitSize(name, {
                      ...options,
                      validate: (value: string) => {
                        const clean = value.trim().toLowerCase();
                        if (normalizedUnits.includes(clean)) {
                          return "Unit name already exists.";
                        }
                        if (clean?.length > 20) {
                          return "Maximum 20 characters allowed";
                        }
                        return true;
                      }
                    })
                  }
                  errors={errorsUnit.sales_unit_name}
                  labelName="Unit Name*"
                  placeholder="Unit Name"
                  name="sales_unit_name"
                  required
                  errorMessage="Unit name is required"
                />
              </Grid.Column>
              <Grid.Column computer={3} tablet={8} mobile={16}>
                <InputNumber
                  transform={{
                    input: (value: any) => (isNaN(value) || value === 0 ? "" : value.toString()),
                    output: (e: any) => {
                      return e;
                    }
                  }}
                  control={control}
                  errors={errorsUnit.sales_unit_size}
                  labelName="Unit Size*"
                  placeholder="Unit Size"
                  name="sales_unit_size"
                  required
                  errorMessage="Unit size is required"
                  customInputValidation={true}
                  otherValidation={{
                    validate: {
                      valueCheck: (v: any) => validateProductNumber(v)
                    }
                  }}
                />
              </Grid.Column>
              <Grid.Column computer={3} tablet={8} mobile={16}>
                <DropDown
                  labelName="Unit Type"
                  placeholder="Type"
                  currentData={UNIT_TYPES}
                  defaultValue={defaultType}
                  customGridColumn="customGridColomnType"
                  handleChangeState={(e: any, { value }: any) => setDefaultType(value)}
                />
              </Grid.Column>
              <Grid.Column computer={4} tablet={8} mobile={16}>
                <InputText
                  register={registerUnitSize}
                  errors={errorsUnit.ean_barcode}
                  labelName="EAN Barcode"
                  placeholder="EAN Barcode"
                  name="ean_barcode"
                />
              </Grid.Column>
              <Grid.Column computer={3} tablet={8} mobile={16}>
                {enableSizeEditStatus ? (
                  <CustomButton
                    theme="green"
                    customColumnStyle={"addUnitSize"}
                    title="UPDATE"
                    onClick={handleSubmitUnitSize((data: any) => {
                      editUnitSize(data);
                    })}
                  />
                ) : enableUnitSizeAdd ? (
                  <CustomButton
                    theme="green"
                    customColumnStyle="addUnitSize"
                    icon
                    iconChild={<PlusIcon />}
                    onClick={handleSubmitUnitSize((data: any) => addUnitData(data))}
                    customBase="productUnitAddButton"
                  />
                ) : null}
              </Grid.Column>
            </Grid>
            {addProductUnit.length > 0 && (
              <Grid.Column computer={16} tablet={16} mobile={16} className="productRegisterTable">
                <CommonTable tableHeaderData={ProductUnitTable}>{loadTableData()}</CommonTable>
              </Grid.Column>
            )}
          </form>
        </Grid.Column>
      </Grid>
    </>
  );
};

export default ProductUnitForm;
